import api from '@http/api';

export interface IFormaContribuicao {
  link_arquivo: string;
  quantidade_item_pagina: number;
  total_pagina: number;
  total_itens: number;
  pagina_atual: number;
  pagina_anterior_existe: boolean;
  pagina_seguinte_existe: boolean;
  valor_total: number;
}

export interface IBuscaControleAlteracao {
  perfilID: number;
  page_number: number;
  page_size: number;
}

export interface IBuscaControleAlteracaoFiltro {
  perfil_id: number;
  tipo_informacao: number;
  data_inicial: string;
  data_final: string;
  page_number: number;
  page_size: number;
}

export interface IControleAlteracao {
  Data: string;
  Tipo_Informacao: string;
  Usuario:string;
  Campo: string;

 }

class ComponentPerfilServices {

  public async buscaPerfilControleAlteracaoFiltro({
    perfil_id,
    tipo_informacao,
    data_inicial,
    data_final,
    page_number,
    page_size,
  }: IBuscaControleAlteracaoFiltro) {
    return await api
      .post('/api/Perfil/GetPerfilControleAlteracaoFiltroByPerfilID', {
        perfil_id,
        tipo_informacao,
        data_inicial,
        data_final,
        page_number,
        page_size,
      })
      .then(response => {
        const controleAlteracaoFiltro = response.data.modelo;
        const total_itens = response.data.total_itens;
        const total_pagina = response.data.total_pagina;
        //const link_arquivo = response.data.link_arquivo;

        var itemControleAlteracaoFiltro: IControleAlteracao[] = [];

        controleAlteracaoFiltro.map((item: IControleAlteracao) => {
          return itemControleAlteracaoFiltro.push({
            Data: item.Data,
            Tipo_Informacao: item.Tipo_Informacao,
            Usuario: item.Usuario,
            Campo: item.Campo

          });
        });

        return {
          error: false,
          response: { total_itens, total_pagina, controleAlteracaoFiltro: itemControleAlteracaoFiltro },
        };
      })
      .catch(error => {
        console.log('caiu aqui', error);

        return {
          error: true,
          response: [],
        };
      });
  }


}

export default ComponentPerfilServices;
